import BaseTableContainer from '@material-ui/core/TableContainer'

const TableContainer = BaseTableContainer

export default TableContainer
